<div class="highlights-dashboard">
  <!-- Top Info Row -->
  <div class="dashboard-info-row">
    <div class="dashboard-info-card repeat-customers">
      <div class="info-title">Total Repeat Customers</div>
      <div class="info-value">{{overallSummary?.repeated_user_count || '0'}}</div>
      <div class="info-desc">Represents the total number of loyal customers across all journey stages who repeatedly
        engage with your brand, showing sustained satisfaction, trust, and loyalty.</div>
    </div>
    <div class="dashboard-info-card repeat-customers-nps" [ngClass]="{
      'unavailable-nps': overallSummary?.npsType == 'unavailable' || !overallSummary?.npsType,
      'positive-nps': overallSummary?.npsType == 'positive',
      'nutral-nps': overallSummary?.npsType == 'neutral',
      'negative-nps': overallSummary?.npsType == 'negative'
     }">
      <div class="info-title">Repeat Customers NPS®</div>
      <div class="info-value">{{overallSummary?.repeated_user_nps || 'NA'}}</div>
      <div class="info-desc">Measures NPS® from repeat customers to reflect their experience and commitment across
        Journey Stages.</div>
    </div>
    <div class="dashboard-info-card total-responses">
      <div class="info-title">Total Responses</div>
      <div class="info-value">{{overallSummary?.total_responses || '0'}}</div>
      <div class="info-desc">Repeat customer responses, indicating satisfaction and loyalty.</div>
    </div>
    <div class="dashboard-info-card promoter">
      <div class="info-title">Promoter ratings</div>
      <div class="info-value">{{overallSummary?.promoter || '0'}}</div>
      <div class="info-desc">Customers highly satisfied and eager to recommend your brand.</div>
    </div>
    <div class="dashboard-info-card passive">
      <div class="info-title">Passive ratings</div>
      <div class="info-value">{{overallSummary?.passive || '0'}}</div>
      <div class="info-desc">Customers who are satisfied but not fully enthusiastic.</div>
    </div>
    <div class="dashboard-info-card detractor">
      <div class="info-title">Detractors Ratings</div>
      <div class="info-value">{{overallSummary?.detractor || '0'}}</div>
      <div class="info-desc">Customers dissatisfied and unlikely to recommend.</div>
    </div>
  </div>

  <!-- Charts Row -->
  <div class="dashboard-charts-row">
    <div class="dashboard-chart-card">
      <div class="chart-header">
        <div class="chart-header-left">
          <div class="chart-title">Repeat Customer Response Distribution</div>
          <div class="chart-desc">Provides a view of repeat customer response distribution across different journeys.
          </div>
        </div>
        <div class="chart-header-right">
          <div class="dropdown-container" #dropdownContainer>
            <div class="dropdown-button" title="{{selectedBarChartjourney}}" (click)="onButtonClick()"
              [ngClass]="{'active': isDropdownOpen}">
              <span class="button-dropdown-text" [innerHTML]="selectedBarChartjourney"></span>
              <span class="dropdown-arrow" [ngStyle]="{ backgroundColor: isDropdownOpen ? '#3777FF33' : '' }">
                <img
                  [ngStyle]="{ filter: isDropdownOpen ? 'brightness(0) saturate(100%) invert(26%) sepia(89%) saturate(1954%) hue-rotate(204deg) brightness(98%) contrast(101%)' : null, transform: isDropdownOpen ? 'rotate(180deg)' : null }"
                  src="assets/images/menu-down-dark.svg">
              </span>
            </div>
            <div class="dropdown-content" *ngIf="isDropdownOpen">
              <ul>
                <li class="dropdown-item" *ngFor="let option of barChartDropdown.options" (click)="onOptionClick(option)"
                  [ngClass]="{'selected': selectedField === option.field_id}">
                  <img src="assets/images/checkbox-blank-outline.svg"
                    *ngIf="!(selectedJourneyIds && selectedJourneyIds.length &&  selectedJourneyIds.indexOf(option.field_id)>=0)"
                    style="width: 24px;">
                  <img src="assets/images/checkbox-marked.svg"
                    *ngIf="(selectedJourneyIds && selectedJourneyIds.length &&  selectedJourneyIds.indexOf(option.field_id)>=0)"
                    style="width: 24px;">
                  <span class="dropdown-text">{{option.name?
                    option.name: option.text}}</span>
                </li>
              </ul>
              <div class="dropdown-footer" >
                <button class="action-btn" [disabled]="selectedJourneyIds.length == 0" (click)="onDoneClick()">Done</button>
              </div>
            </div>
          </div>
          <div class="card-button-group">
            <button class="button " [class.active]="barChartType == 'percent'" (click)="changeBarChartType('percent')">
              <img src="assets/images/bar-chart-percent.svg" class="opacity" alt="bar-chart-percent">
            </button>
            <button class="button" [class.active]="barChartType == 'absolute'" (click)="changeBarChartType('absolute')">
              <img src="assets/images/bar_chart.svg" class="opacity" alt="bar-chart">
            </button>
          </div>
        </div>
      </div>
      <div class="chart-container">
        <ng-container *ngIf="!isRatingDistributionLoading && barChartConfig.data?.labels?.length > 0">
          <app-litmus-chart-beta [chartConfigs]="barChartConfig"
            [chartData]="barChartConfig.data"></app-litmus-chart-beta>
        </ng-container>
        <div class="card-error-message" *ngIf="!isRatingDistributionLoading && barChart?.labels?.length == 0">
          <div class="no-data-text">No data available</div>
        </div>
        <div class="card-loader" *ngIf="isRatingDistributionLoading">
          <app-ltms-loader></app-ltms-loader>
        </div>
      </div>
    </div>
    <div class="dashboard-chart-card">
      <div class="chart-header">
        <div class="chart-header-left">
          <div class="chart-title">Repeat Customer NPS Trend</div>
          <div class="chart-desc">Provides a view of how repeat customer NPS changes across journeys.</div>
        </div>
        <div class="chart-header-right">
          <app-score-dropdown-menu [config]="lineChartDropdown.config"
            [selectedOption]="lineChartDropdown['selectedOption']" [options]="lineChartDropdown.options"
            (selectedOptionChange)="changeLineChartView($event)"></app-score-dropdown-menu>
          <div class="card-button-group">
            <button class="button " style="width: 83px;" [class.active]="lineChartType == 'monthly'"
              (click)="changeLineChartType('monthly')">
              Monthly
            </button>
            <button class="button " style="width: 71px;" [class.active]="lineChartType == 'yearly'"
              (click)="changeLineChartType('yearly')">
              Yearly
            </button>
          </div>
        </div>
      </div>
      <div class="chart-container">
        <ng-container *ngIf="!isJourneySummaryLoading && lineChartConfig?.data?.labels?.length > 0">
          <app-litmus-chart-beta [chartConfigs]="lineChartConfig"
            [chartData]="lineChartConfig.data"></app-litmus-chart-beta>
        </ng-container>
        <div class="card-error-message" *ngIf="!isJourneySummaryLoading && lineChartData?.labels?.length == 0">
          <div class="no-data-text">No data available</div>
        </div>
        <div class="card-loader" *ngIf="isJourneySummaryLoading">
          <app-ltms-loader></app-ltms-loader>
        </div>
      </div>
    </div>
  </div>

  <!-- Tables Row -->
  <div class="dashboard-tables-row">
    <div class="dashboard-table-card max-height">
      <div class="table-title">Repeat Customers - Detailed View</div>
      <div class="table-desc">Provides a detailed view of repeat customer NPS, responses, and rating distribution.</div>
      <div class="card-loader" *ngIf="isUserSummaryLoading">
        <app-ltms-loader></app-ltms-loader>
      </div>
      <div class="card-error-message" *ngIf="this.customers.length == 0 && !isUserSummaryLoading">
        <div class="no-data-text">No data available</div>
      </div>
      <div class="table-responsive" *ngIf="this.customers.length > 0 && !isUserSummaryLoading">
        <table>
          <thead>
            <tr>
              <th>Unique Identifier</th>
              <th>Customer NPS®</th>
              <th>Responses</th>
              <th>Promoter ratings</th>
              <th>Passive ratings</th>
              <th>Detractor ratings</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let customer of customers">
              <td class="customer-id-link" (click)="openCustomerJourney(customer)">
                <img src="assets/images/launch.svg" alt="launch" class="launch-icon">
                {{customer.id}}
              </td>
              <td>{{customer.nps}}</td>
              <td>{{customer.total_responses}}</td>
              <td>{{customer.promoter}}</td>
              <td>{{customer.passive}}</td>
              <td>{{customer.detractor}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="dashboard-table-card">
      <div class="table-title">Project-Wise Repeat Response Breakdown</div>
      <div class="table-desc">Highlights repeat response counts and NPS for projects.</div>
      <div class="card-loader" *ngIf="isProjectSummaryLoading">
        <app-ltms-loader></app-ltms-loader>
      </div>
      <div class="card-error-message" *ngIf="this.projects.length == 0 && !isProjectSummaryLoading">
        <div class="no-data-text">No data available</div>
      </div>
      <div class="table-responsive" *ngIf="this.projects.length > 0 && !isProjectSummaryLoading">
        <table>
          <thead>
            <tr>
              <th>Project Name</th>
              <th>Responses</th>
              <th>Promoter</th>
              <th>Passive</th>
              <th>Detractor</th>
              <th>Repeat Customer NPS®</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let project of projects">
              <td class="project-name">{{project.name}}</td>
              <td>{{project.total_responses}}</td>
              <td>{{project.promoter}}</td>
              <td>{{project.passive}}</td>
              <td>{{project.detractor}}</td>
              <td>{{project.nps}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="selectedCustomer">
  <app-customer-journey-view class="side-panel" [customerDetail]="selectedCustomer"
    (closePanel)="closeCustomerJourney()"></app-customer-journey-view>
</ng-container>